import React from 'react';
import './PageHeader.scss';
import searchIcon from './searchReg.svg';
import addIcon from './plus.svg';

const SearchHeader = (props) => {
  const {
    onClick,
    onChange,
    placeholder,
    searchValue,
    buttonText,
    button,
    showInput,
    showButton,
  } = props;

  return (
    <div className="registry-search-header">
      {showInput ? (
        <div className="registry-search-header__input">
          <>
            <input
              type="text"
              className="search-field"
              placeholder={placeholder}
              onChange={(e) => onChange(e)}
              value={searchValue}
            />
            <img src={searchIcon} alt="search" style={{width: "12px"}}/>
          </>
        </div>
      ) : (
        <div></div>
      )}
      {showButton &&
        (buttonText ? (
          <button
            className="registry-search-header__button--submit"
            onClick={onClick}
          >
            <img src={addIcon} alt="add" />
            {buttonText}
          </button>
        ) : (
          <div className="registry-modal-button">{button}</div>
        ))}
    </div>
  );
};

export default SearchHeader;